import React from "react";
import ToDo from "./Components/ToDo";
import './index.css'

function App() {
  return (
    <div className="app">
      <ToDo/>
    </div>
  );
}

export default App;